// Material UI
import { makeStyles } from '@material-ui/core'
// Consts
import Colors from '../../../constants/Colors'

export default makeStyles(theme => {
  return {
    root: {
      alignItems: 'center',
      color: Colors.SECONDARY_FONT_COLOR,
      display: 'flex',
      fontFamily: 'Poppins',
      fontSize: 15,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      height: '100%',
      padding: '0px 54px',
      textAlign: 'center',
    },
  }
})
